/* COPBUSTERS-SEZIONE-JP: file della Sezione JP di Copbusters (script), scritto da Dropship Sync. Non modificarlo: al prossimo invio viene riscritto (generato da apps/reseller-blocks/scripts/sezioni-tema.mjs). */
if (!window.copbustersSezioneJp) {
window.copbustersSezioneJp = true;
/* Timer Sezione JP — app block per i negozi dei rivenditori.
   Apre il lunedi' alle 12:00 e chiude il martedi' alle 11:00, ora di Roma (ora legale e solare
   comprese): la stessa regola del timer sul negozio Copbusters. Aperta = testi "aperta" e bottone;
   chiusa = testi "chiusa", niente bottone. Nell'editor del tema si puo' forzare una delle due viste. */
(function () {
  'use strict';

  var WEEKDAY = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
  var romeFmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Rome', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  function romeParts(date) {
    var parts = {};
    romeFmt.formatToParts(date).forEach(function (p) { parts[p.type] = p.value; });
    return parts;
  }

  // Un'ora "da orologio" di Roma (anno, mese, giorno, ore, minuti) → l'istante vero
  function romeWallToUTC(y, mo, d, h, mi) {
    var guess = new Date(Date.UTC(y, mo - 1, d, h, mi, 0));
    var p = romeParts(guess);
    var asIfUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    return new Date(guess.getTime() - (asIfUTC - guess.getTime()));
  }

  function addDays(y, mo, d, days) {
    var dt = new Date(Date.UTC(y, mo - 1, d));
    dt.setUTCDate(dt.getUTCDate() + days);
    return { y: dt.getUTCFullYear(), mo: dt.getUTCMonth() + 1, d: dt.getUTCDate() };
  }

  // La finestra di questa settimana e della prossima. La settimana dopo si calcola sulla data di
  // Roma (non +7 giorni in UTC): nella settimana del cambio d'ora resta alle 12:00 e alle 11:00.
  function schedule(now) {
    var p = romeParts(now);
    var monday = addDays(+p.year, +p.month, +p.day, -WEEKDAY[p.weekday]);
    var open = romeWallToUTC(monday.y, monday.mo, monday.d, 12, 0);
    var tue = addDays(monday.y, monday.mo, monday.d, 1);
    var close = romeWallToUTC(tue.y, tue.mo, tue.d, 11, 0);
    var nextMonday = addDays(monday.y, monday.mo, monday.d, 7);
    var nextTue = addDays(monday.y, monday.mo, monday.d, 8);
    return {
      open: now >= open && now < close,
      nextOpen: now < open ? open : romeWallToUTC(nextMonday.y, nextMonday.mo, nextMonday.d, 12, 0),
      nextClose: now < close ? close : romeWallToUTC(nextTue.y, nextTue.mo, nextTue.d, 11, 0)
    };
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  var MAX = { d: 7, h: 24, m: 60, s: 60 };

  function init(root) {
    if (root.__cbtReady) return;
    root.__cbtReady = true;

    var forced = root.getAttribute('data-design-mode') === 'true' ? root.getAttribute('data-preview') : 'auto';
    var copies = {
      closed: root.querySelector('[data-cbt-copy="closed"]'),
      open: root.querySelector('[data-cbt-copy="open"]')
    };
    var label = root.querySelector('[data-cbt-label]');
    var cta = root.querySelector('[data-cbt-cta]');
    var units = {};
    ['d', 'h', 'm', 's'].forEach(function (k) {
      var u = root.querySelector('[data-cbt-unit="' + k + '"]');
      if (u) units[k] = { num: u.querySelector('[data-cbt-n]'), bar: u.querySelector('.cbt__ring-bar') };
    });
    var shown = null;
    var timer = null;

    function show(isOpen) {
      shown = isOpen;
      root.classList.toggle('cbt--open', isOpen);
      if (copies.closed) copies.closed.hidden = isOpen;
      if (copies.open) copies.open.hidden = !isOpen;
      if (cta) cta.hidden = !isOpen;
      if (label) label.textContent = label.getAttribute(isOpen ? 'data-open' : 'data-closed') || '';
    }

    function tick() {
      if (!root.isConnected) { clearInterval(timer); return; } // blocco tolto o sezione ricaricata nell'editor
      var now = new Date();
      var st = schedule(now);
      var isOpen = forced === 'open' ? true : forced === 'closed' ? false : st.open;
      if (isOpen !== shown) show(isOpen);
      var left = Math.max(0, Math.floor(((isOpen ? st.nextClose : st.nextOpen) - now) / 1000));
      var val = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
      Object.keys(units).forEach(function (k) {
        var u = units[k];
        if (u.num) u.num.textContent = pad(val[k]);
        if (u.bar) u.bar.style.setProperty('--cbt-off', String(100 - Math.min(100, (val[k] / MAX[k]) * 100)));
      });
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-cbt]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // editor del tema: blocco aggiunto o impostazioni cambiate = sezione ri-renderizzata
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  // «Portami alla sezione» (blocco Testo Sezione JP): su al timer della pagina, se no in cima
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-cbt-scroll]') : null;
    if (!link) return;
    e.preventDefault();
    var timer = link.getAttribute('data-cbt-scroll') === 'timer' ? document.querySelector('[data-cbt]') : null;
    var smooth = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (timer) timer.scrollIntoView({ behavior: smooth, block: 'start' });
    else window.scrollTo({ top: 0, behavior: smooth });
  });
})();

}
